import ProductDetail from '@/views/productDetail/ProductDetail.vue'

export default [
  {
    path: '/productdetail',
    name: 'productDetail',
    component: ProductDetail,
    meta: {
      title: '产品详情'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/productDetail.js